import type { FC, ReactElement } from 'react';

import type { ButtonClick } from '@snowit/icetypes/events';

import ButtonIcon from '../../../Buttons/ButtonIcon';
import Typo from '../../../Typography/Typo';

import cx from 'classnames';
import s from './DropdownHeader.module.scss';

export interface IDropdownHeader {
  title?: string;
  onClick?: (params: ButtonClick) => void;
  classNames?: {
    wrapper?: string;
    title?: string;
    button?: string;
  };
}

const DropdownHeader: FC<IDropdownHeader> = (props: IDropdownHeader): ReactElement => {
  const { title, onClick, classNames } = props;

  const renderTitle = () => {
    if (!title) return null;
    return (
      <Typo
        className={cx(s.title, classNames?.title)}
        text={title}
        tag={'h2'}
        size={'df'}
        weight={'medium'}
        color={'text'}
      />
    );
  };

  const renderClose = () => {
    return (
      <ButtonIcon
        classNames={{ button: cx(s.closeBtn, classNames?.button) }}
        icon={'close'}
        onClick={onClick}
        theme={'ghost'}
        size={'db'}
        color={'text'}
      />
    );
  };

  return (
    <div className={cx(s.wrapper, classNames?.wrapper)}>
      {renderTitle()}
      {renderClose()}
    </div>
  );
};

export default DropdownHeader;
